import * as React from "react";

const InstructionsIcon = (props) => (
<svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={16}
    height={16}
    viewBox="0 0 20.406 20.406"
    {...props}
>  
    <path d="M20.166.139a.641.641,0,0,1,.1.1l.015.019q.017.023.032.048l.018.032a.636.636,0,0,1,.073.3V5.956a.638.638,0,0,1-1.275,0V2.177l-8.668,8.668a.638.638,0,1,1-.9-.9l8.668-8.668H14.45A.638.638,0,0,1,14.45,0h5.318a.635.635,0,0,1,.4.139ZM1.275,3.826a1.505,1.505,0,0,1,.335-.893.877.877,0,0,1,.647-.382H8.673a.638.638,0,0,0,0-1.275H2.257a2.138,2.138,0,0,0-1.643.861A2.777,2.777,0,0,0,0,3.826V18.149a2.26,2.26,0,0,0,2.257,2.257H16.58a2.794,2.794,0,0,0,2.551-2.551V11.734a.638.638,0,0,0-1.275,0v6.122a1.562,1.562,0,0,1-1.275,1.275H2.257a.984.984,0,0,1-.982-.982Z" />
</svg>  
)

export default InstructionsIcon;
